import { render } from "./ThinkingAbilityForm.vue?vue&type=template&id=5ec5d4a2&scoped=true"
import script from "./ThinkingAbilityForm.vue?vue&type=script&lang=js"
export * from "./ThinkingAbilityForm.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./ThinkingAbilityForm.vue?vue&type=style&index=1&id=5ec5d4a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec5d4a2"]])

export default __exports__